export {KokosI18NextPipe as I18NextPipe} from './kokos-i18next.pipe';